import { lazy } from 'react';

const Create = lazy(() => import('./Create'));

export { Create };
